import React from 'react';
import { FormattedMessage } from 'react-intl';
import P from '../../../../../components/P';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';

export default function FraudNotice() {
  return (
    <div>
      <Section>
        <ControlContainer>
          <P>
            <FormattedMessage {...messages.fraudNoticeVisitorsToCanada} id={messages.fraudNoticeVisitorsToCanada.id} />
          </P>
        </ControlContainer>
      </Section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/TugoFraudNotice/index.js